// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__20dHg","head":"Table_head__2DvmH","col":"Table_col__gewRJ"};